import { Channel, SMSChannel } from "../enums/channel";
import { PracticeFeature } from "../enums/practice-feature";
import { ChannelOption } from "../interfaces/channel-option.interface";
import { Practice } from "../models/Practice";
import { practiceHasFeature } from "./practice-has-feature";

export function getPermittedMessagingChannels(practice: Practice, forBroadcast: boolean = false): ChannelOption[] {
    let channels: ChannelOption[] = [];
    let waChannelCode: Channel = Channel.WHATSAPP;
    let smsChannelCode: Channel = Channel.SMS;

    const smsMessaging = practiceHasFeature(practice, PracticeFeature.SMS_MESSAGING);
    const whatsappMessaging = practiceHasFeature(practice, PracticeFeature.WHATSAPP_MESSAGING);
    const whatsappForBroadcast = practiceHasFeature(practice, PracticeFeature.WHATSAPP_BROADCASTS);
    const facebookMessaging = practiceHasFeature(practice, PracticeFeature.FACEBOOK_MESSENGER);
    const instagramMessaging = practiceHasFeature(practice, PracticeFeature.INSTAGRAM);
    
    if (
        practice.whatsapp_channel === Channel.WHATSAPP360 ||
        practice.whatsapp_channel === Channel.WHATSAPP360CLOUD
    ) {
        waChannelCode = practice.whatsapp_channel
    }
    
    if (
        practice.sms_channel === SMSChannel.Infobip
    ) {
        smsChannelCode = Channel.SMSInfobip;
    }

    if (whatsappMessaging && !forBroadcast) {
        channels.push({
            name: Channel.WHATSAPP,
            code: Channel.WHATSAPP,
            className: Channel.WHATSAPP.toLowerCase(),
            icon: 'WhatsApp.svg',
            inactive: !whatsappMessaging,
        });
    }

    if (whatsappForBroadcast && forBroadcast) {
        channels.push({
            name: Channel.WHATSAPP,
            code: waChannelCode,
            className: Channel.WHATSAPP.toLowerCase(),
            icon: 'WhatsApp.svg',
            inactive: !whatsappForBroadcast,
        });
    }

    if (smsMessaging) {
        channels.push(
            {
                name: Channel.SMS,
                code: smsChannelCode,
                className: Channel.SMS.toLowerCase(),
                icon: 'SMS.svg',
                inactive: !smsMessaging,
            }
        );
    }

    if (facebookMessaging) {
        channels.push({
            name: Channel.FACEBOOK,
            code: Channel.FACEBOOK,
            className: Channel.FACEBOOK.toLowerCase(),
            icon: "facebook-messenger.svg",
            inactive: false,
        });
    }
              
    if (instagramMessaging) {
        channels.push({
            name: Channel.INSTAGRAM,
            code: Channel.INSTAGRAM,
            className: Channel.INSTAGRAM.toLowerCase(),
            icon: "instagram.svg",
            inactive: false,
        });
    }

    channels = channels.sort((a, b) =>
        a.inactive === b.inactive ? 0 : a.inactive ? 1 : -1
    );

    return channels;
}
